import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const CustomerReceivableActiveData = createSlice({
  name: "CustomerReceivableActiveData",
  initialState: {
    data: {},
  },
  reducers: {
    addCustomerDataData: (state, action?: any) => {
      state.data = action.payload;
    },
    clearCustomerDataData: (state) => {
      state.data = {};
    },
  },
});
export default CustomerReceivableActiveData.reducer;
export const { addCustomerDataData, clearCustomerDataData } =
  CustomerReceivableActiveData.actions;
